<template>
  <v-container fluid class="d-flex justify-center" :style="`margin-left: ${margin}`">
    <div class="report-wrapper">
      <!-- Sticky Filter Header -->
      <div class="table-header-filters">
        <v-row dense class="align-center">
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete
              class="filter-select"
              dense
              outlined
              hide-details
              label="Prodajno mjesto"
              v-model="location"
              :items="locations"
              item-text="name"
              item-value="id"
              return-object
              @change="getData()"
            ></v-autocomplete>
          </v-col>

          <!-- Action Cluster -->
          <v-col cols="auto" class="ml-auto d-flex align-center" style="gap: 8px">
            <v-btn :disabled="locationNotSelected" class="search-btn" @click="getData()" small>
              <v-icon small class="mr-1">mdi-magnify</v-icon>
              Pretraži
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-menu offset-y left :close-on-content-click="true">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-btn icon class="export-btn" v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                      <v-icon color="#00b3be">mdi-export-variant</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense style="border-radius: 12px; overflow: hidden; padding: 4px; min-width: 140px;">
                    <v-list-item @click="changeWidth()">
                      <v-icon size="18" color="#E53935" class="mr-2">mdi-file-pdf-box</v-icon>
                      <v-list-item-title>PDF</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="generateExcel()">
                      <v-icon size="18" color="#43A047" class="mr-2">mdi-file-excel</v-icon>
                      <v-list-item-title>Excel</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="generateCSV()">
                      <v-icon size="18" color="#0288D1" class="mr-2">mdi-file-delimited</v-icon>
                      <v-list-item-title>CSV</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <span>Izvoz podataka</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon :to="to" class="close-btn" v-bind="attrs" v-on="on">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Zatvori izvještaj</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>

      <!-- Glass Table Wrapper -->
      <div class="glass-table-wrapper">
        <div id="table_info" class="table-content">
          <!-- Hidden company info table for PDF -->
          <table id="firma" style="display: none; font-family: 'Roboto-Regular'">
            <tbody>
              <tr>
                <td>{{ company ? $options.filters.capitalize(company.name) : "" }}</td>
              </tr>
              <tr>
                <td>{{ company ? company.address + " " + company.city : "" }}</td>
              </tr>
              <tr>
                <td>OIB: {{ company ? company.oib : "" }}</td>
              </tr>
              <tr>
                <td>Prodajno mjesto: {{ location ? location.name : "" }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Report Title -->
          <div style="font-family: Raleway, sans-serif">
            <table justify="center" style="width: 100% !important" cellspacing="0" id="title">
              <thead>
                <tr class="header">
                  <th colspan="6">
                    <p class="gradient-text" style="font-size: 25px; text-align: center;">
                      Cjenik
                    </p>
                  </th>
                </tr>
              </thead>
            </table>
          </div>

          <!-- Pricelist Table -->
          <div justify="center">
            <table
              justify="center"
              style="width: 100% !important"
              cellspacing="0"
              id="tableTraffic"
            >
              <thead>
                <tr :class="['header', 'naslov']" style="display: none">
                  <th colspan="6">
                    <span style="font-weight: bold">Cjenik</span>
                  </th>
                </tr>
                <tr :class="['header', 'naslov']">
                  <th v-if="viewType !== 'pdf'" style="text-align: left">Šifra</th>
                  <th style="text-align: left">Naziv artikla</th>
                  <th style="text-align: right">Cijena</th>
                  <th v-if="viewType !== 'pdf'" style="text-align: right">PDV %</th>
                </tr>
              </thead>
              <tbody style="width: 100% !important">
                <template v-for="(items, category) in allItems">
                  <!-- Category header row -->
                  <tr :key="category" class="category-header">
                    <td :colspan="viewType === 'pdf' ? 2 : 4" style="text-align: center; font-weight: bold">
                      {{ $options.filters.capitalize(category) }}
                    </td>
                  </tr>
                  <!-- Item rows within category -->
                  <tr v-for="(item, itIdx) in items" :key="item.id + itIdx">
                    <td v-if="viewType !== 'pdf'" style="text-align: left">
                      {{ item.code || '-' }}
                    </td>
                    <td style="text-align: left">
                      {{ $options.filters.capitalize(item.name) }}
                    </td>
                    <td style="text-align: right">
                      <span v-if="item.prices[currency] && item.prices[currency].price !== null">
                        {{
                          viewType === "pdf"
                            ? $options.filters.money(item.prices[currency].price, 100, currency)
                            : (item.prices[currency].price / 100).toFixed(2)
                        }}
                      </span>
                      <span v-else style="font-style: italic; color: #999;">
                        -
                      </span>
                    </td>
                    <td v-if="viewType !== 'pdf'" style="text-align: right">
                      <span v-if="item.prices[currency] && item.prices[currency].taxes && item.prices[currency].taxes.length > 0 && item.prices[currency].taxes[0].rate !== null && item.prices[currency].taxes[0].rate !== undefined">
                        {{ (item.prices[currency].taxes[0].rate / 100).toFixed(0) }}%
                      </span>
                      <span v-else style="font-style: italic; color: #999;">
                        -
                      </span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { clone } from '@/plugins/utils'
import { df, auth } from '@/plugins/firebase'
import state from '@/state'
import 'jspdf-autotable'
import { saveExcel } from '@/modules/all-reports/xlsx/config.js'
import EventBus from '@/plugins/event-bus'
import { initPdf, setTable, setPageNumber } from '@/modules/all-reports/pdf/config.js'

export default {
  name: 'Reports',
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  components: {},
  data: function () {
    return {
      allItems: [],
      company: undefined,
      tableWidth: '1200px',
      a4PortraitWidth: '575px',
      a4LandscapeWidth: '610px',
      targetModifier: '',
      viewType: 'pdf',
      itemReport: [],
      totalReport: {},
      currency: 'EUR',
      location: null,
      locations: [],
      margin: '0px'
    }
  },
  computed: {
    to () {
      return { name: `${this.targetModifier}.all-reports.reportMenu` }
    },
    formatDateTo () {
      return new Intl.DateTimeFormat('hr-HR', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }).format(new Date(this.dateTo))
    },
    formatDateFrom () {
      return new Intl.DateTimeFormat('hr-HR', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }).format(new Date(this.dateFrom))
    },
    locationNotSelected () {
      return !this.location || !this.location.id
    }
  },
  async created () {
    this.margin = state.getMargin()
    await this.getPointsOfSale()
  },
  mounted () {
    var sideNav = this.$route.meta.sideNav
    switch (sideNav) {
      case 'Companies':
        break
      case 'Company':
        this.targetModifier = 'company'
        break
      case 'PointOfSale':
        this.targetModifier = 'pointOfSale'
        break
      case 'CashRegister':
        this.targetModifier = 'pointOfSale'
        break
    }

    EventBus.$on('set-mini', () => {
      this.margin = state.getMargin()
    })

    this.company = clone(state.getCurrentCompany())
    this.location = clone(state.getPointOfSale())
    this.getData()
  },
  methods: {
    async getData () {
      var tempItem = []
      this.allItems = {} // Object for category grouping

      try {
        const posId = this.location !== null ? this.location.id : state.getPointOfSale().id

        const documentSnapshots = await df
          .collection(`location_pricelist/${posId}/items`)
          .where('active', '==', true)
          .where('status', '==', 'OK')
          .get()

        if (documentSnapshots.docs && !documentSnapshots.docs.empty) {
          documentSnapshots.docs.forEach((item) => {
            tempItem.push(item.data())
          })
        } else {
          this.showMsgBox({
            text: 'Nema artikala za prikaz u odabranom prodajnom mjestu.',
            actions: ['cancel'],
            cancelBtnText: 'U redu',
            color: 'info'
          })
          return
        }
      } catch (error) {
        console.error('Error loading pricelist:', error)
        this.showMsgBox({
          text: 'Greška pri učitavanju cjenika. Molimo pokušajte ponovno.',
          actions: ['cancel'],
          cancelBtnText: 'U redu',
          color: 'error'
        })
        this.allItems = {}
        return
      }

      // Fix: Proper string sorting with Croatian locale
      tempItem.sort((a, b) => {
        const nameA = (a.name || '').toLowerCase()
        const nameB = (b.name || '').toLowerCase()
        return nameA.localeCompare(nameB, 'hr')
      })

      var warehouseItemsCount = 0
      var simpleItemsCount = 0
      var itemsWithPriceCount = 0
      var itemsWithoutPriceCount = 0

      tempItem.forEach((item, idx) => {
        if (item.warehouse_units && item.warehouse_units.base_unit) {
          var whUnits = clone(item.warehouse_units)
          warehouseItemsCount++

          Object.keys(whUnits.units).forEach((key) => {
            var itemCopy = clone(item)
            itemCopy.prices = whUnits.units[key].prices
            itemCopy.storage_unit = whUnits.units[key].storage_unit
            itemCopy.selling_unit = whUnits.units[key].storage_unit
            itemCopy.itemType = 'warehouse'
            itemCopy.categoriesFormatted = ''

            // Fix: Handle categories with null check and default
            if (item.categories && item.categories.length > 0) {
              item.categories.forEach((cat, cidx) => {
                if (cidx === 0) {
                  itemCopy.categoriesFormatted = cat.name
                } else {
                  itemCopy.categoriesFormatted = itemCopy.categoriesFormatted + ', ' + cat.name
                }
              })
            } else {
              itemCopy.categoriesFormatted = 'Bez kategorije'
            }

            // Only add items with valid prices
            if (itemCopy.prices && itemCopy.prices[this.currency] && itemCopy.prices[this.currency].price) {
              itemsWithPriceCount++
              if (!this.allItems[itemCopy.categoriesFormatted]) {
                this.allItems[itemCopy.categoriesFormatted] = []
              }
              this.allItems[itemCopy.categoriesFormatted].push(itemCopy)
            } else {
              itemsWithoutPriceCount++
            }
          })
        } else {
          // Simple items
          simpleItemsCount++
          // Fix: Rename to avoid variable shadowing
          var itemCopy = clone(item)
          itemCopy.itemType = 'simple'
          itemCopy.categoriesFormatted = ''

          // Fix: CRITICAL null check for categories
          if (item.categories && item.categories.length > 0) {
            item.categories.forEach((cat, cidx) => {
              if (cidx === 0) {
                itemCopy.categoriesFormatted = cat.name
              } else {
                itemCopy.categoriesFormatted = itemCopy.categoriesFormatted + ', ' + cat.name
              }
            })
          } else {
            itemCopy.categoriesFormatted = 'Bez kategorije'
          }

          // Only add items with valid prices
          if (itemCopy.prices && itemCopy.prices[this.currency] && itemCopy.prices[this.currency].price) {
            itemsWithPriceCount++
            if (!this.allItems[itemCopy.categoriesFormatted]) {
              this.allItems[itemCopy.categoriesFormatted] = []
            }
            this.allItems[itemCopy.categoriesFormatted].push(itemCopy)
          } else {
            itemsWithoutPriceCount++
          }
        }
      })

      // Sort items within each category with Croatian locale
      Object.keys(this.allItems).forEach((category) => {
        this.allItems[category].sort((a, b) => {
          const nameA = (a.name || '').toLowerCase()
          const nameB = (b.name || '').toLowerCase()
          return nameA.localeCompare(nameB, 'hr')
        })
      })
      this.$forceUpdate()
    },
    changeWidth () {
      this.showLoader('', { opacity: 1 })
      const tableInfo = document.getElementById('table_info')
      tableInfo.style.width = this.a4PortraitWidth
      tableInfo.style.fontSize = '80%'

      this.generatePdf()
    },
    async generatePdf () {
      const that = this
      const tableInfo = document.getElementById('table_info')
      try {
        var doc = await initPdf()

        doc = await setTable(doc, '#firma', 10)
        var finalY = doc.lastAutoTable.finalY || 10
        doc = await setTable(doc, '#title', finalY)
        finalY = doc.lastAutoTable.finalY || 10
        doc = await setTable(doc, '#tableTraffic', finalY)

        doc = await setPageNumber(doc)

        doc.save('Cjenik.pdf')
      } catch (error) {
        console.error('PDF generation error:', error)
      } finally {
        tableInfo.style.width = that.tableWidth
        tableInfo.style.fontSize = '100%'
        this.viewType = 'pdf'
        that.hideLoader()
      }
    },
    generateExcel () {
      this.showLoader('', { opacity: 1 })
      this.viewType = 'excel'
      setTimeout(() => {
        var tables = ['firma', 'title', 'tableTraffic']
        var fileName = 'Cjenik.xlsx'

        saveExcel(tables, fileName)

        this.viewType = 'pdf'
        this.hideLoader()
      }, 1000)
    },
    generateCSV () {
      this.showLoader('', { opacity: 1 })

      try {
        // CSV header
        let csvContent = 'Šifra;Naziv artikla;Cijena;PDV %\n'

        // Iterate through all categories and items
        Object.keys(this.allItems).forEach((category) => {
          this.allItems[category].forEach((item) => {
            const code = item.code || '-'
            const name = item.name || '-'

            // Get price
            let price = '-'
            if (item.prices && item.prices[this.currency] && item.prices[this.currency].price !== null) {
              price = (item.prices[this.currency].price / 100).toFixed(2)
            }

            // Get tax rate
            let taxRate = '-'
            if (item.prices && item.prices[this.currency] &&
                item.prices[this.currency].taxes &&
                item.prices[this.currency].taxes.length > 0 &&
                item.prices[this.currency].taxes[0].rate !== null) {
              taxRate = (item.prices[this.currency].taxes[0].rate / 100).toFixed(0)
            }

            // Escape fields that contain semicolons or quotes
            const escapedName = name.includes(';') || name.includes('"')
              ? `"${name.replace(/"/g, '""')}"`
              : name

            csvContent += `${code};${escapedName};${price};${taxRate}\n`
          })
        })

        // Create blob with UTF-8 BOM for proper Croatian character encoding
        const BOM = '\uFEFF'
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })

        // Create download link
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', 'Cjenik.csv')
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.showMsgBox({
          text: 'CSV datoteka uspješno generirana!',
          actions: ['cancel'],
          cancelBtnText: 'U redu',
          color: 'success'
        })
      } catch (error) {
        console.error('CSV generation error:', error)
        this.showMsgBox({
          text: 'Greška pri generiranju CSV datoteke.',
          actions: ['cancel'],
          cancelBtnText: 'U redu',
          color: 'error'
        })
      } finally {
        this.hideLoader()
      }
    },
    async getPointsOfSale () {
      const docRef = df.doc(`user_locations/${auth.currentUser.uid}.${state.getCurrentCompany().id}`)
      docRef.onSnapshot((doc) => {
        var locations = Object.values(doc.data().locations)
        locations.forEach((location, index) => {
          this.locations.push(location)
        })
        // Sort alphabetically
        this.locations.sort((a, b) => a.name.localeCompare(b.name))
      })
    }
  }
}
</script>

<style scoped>
/* Report Wrapper */
.report-wrapper {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

/* Sticky Filter Header */
.table-header-filters {
  position: -webkit-sticky;
  position: sticky;
  top: 64px;
  z-index: 10;
  background: #ffffff;
  padding: 16px;
  margin-bottom: 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
}

.table-header-filters >>> .v-row {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.table-header-filters >>> .v-row:first-child {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

/* Filter Select Inputs */
.filter-select.v-text-field--outlined >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  min-height: 36px !important;
  border-radius: 8px !important;
}

.filter-select >>> .v-select__selection,
.filter-select >>> .v-text-field__slot input {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
}

.filter-select >>> label {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: rgba(57, 137, 201, 0.8) !important;
}

.close-btn {
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  border-radius: 10px !important;
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(229, 57, 53, 0.2) !important;
  color: #e53935 !important;
  transition: all 0.2s ease !important;
  box-shadow: none !important;
}

.close-btn:hover {
  background: rgba(229, 57, 53, 0.07) !important;
  box-shadow: 0 0 0 3px rgba(229, 57, 53, 0.1) !important;
}

.search-btn {
  height: 36px !important;
  padding: 0 14px !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
  background: rgba(255, 255, 255, 0.95) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  transition: all 0.2s ease !important;
}

.search-btn:hover:not(:disabled) {
  border-color: #3989C9 !important;
  box-shadow: 0 2px 6px rgba(57, 137, 201, 0.2) !important;
}

.search-btn:disabled {
  opacity: 0.45 !important;
}

.export-btn {
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  border-radius: 10px !important;
  background: rgba(0, 179, 190, 0.06) !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  transition: all 0.2s ease !important;
}

.export-btn:hover {
  background: rgba(0, 179, 190, 0.12) !important;
  box-shadow: 0 0 0 3px rgba(0, 179, 190, 0.12) !important;
}

/* Glass Table Wrapper */
.glass-table-wrapper {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  padding: 30px;
  overflow-x: auto;
}

/* Table Content */
.table-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  font-size: 16px;
  font-family: 'Roboto-Regular', sans-serif;
}

/* Gradient Text */
.gradient-text {
  font-weight: 700 !important;
  color: #2d3748 !important;
  -webkit-text-fill-color: #2d3748 !important;
  letter-spacing: 0.3px !important;
  display: inline-block !important;
  margin: 0;
  padding: 0;
}

/* Table Styling */
#tableTraffic {
  border-collapse: collapse;
}

.glass-table-wrapper table {
  border-collapse: collapse;
  width: 100%;
  border: none;
}

.glass-table-wrapper table th,
.glass-table-wrapper table td {
  padding: 14px 20px;
  border: none;
  border-bottom: 1px solid #EDF2F7;
  font-variant-numeric: tabular-nums;
}

.glass-table-wrapper table tbody tr:hover:not(.naslov):not(.row-total) {
  background: #F7FAFC;
}

/* Header Row */
.naslov {
  background: #F8FAFC !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  color: #2D3748 !important;
}
.naslov th, .naslov td {
  color: #2D3748 !important;
  border-bottom: 2px solid #EDF2F7 !important;
}

.row-total {
  background: rgba(0, 188, 212, 0.03) !important;
  border-top: 2px solid rgba(0, 188, 212, 0.2) !important;
}
.row-total th, .row-total td {
  color: #00b3be !important;
  font-weight: 700 !important;
  border-bottom: 1px solid rgba(0, 188, 212, 0.15) !important;
}

.report-content-wrapper {
  margin-top: 40px;
}

/* Category Header */
.category-header td {
  background: #F8FAFC !important;
  padding: 12px 20px !important;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #2D3748 !important;
  border-bottom: 2px solid #EDF2F7 !important;
}

/* Responsive Design */
@media (max-width: 960px) {
  .glass-table-wrapper {
    padding: 16px;
  }

  .table-content {
    font-size: 14px;
  }
}

@media (max-width: 600px) {
  .table-header-filters {
    padding: 12px;
  }

  .glass-table-wrapper {
    padding: 12px;
  }

  .table-content {
    font-size: 13px;
  }
}
</style>
